module.exports = __webpack_public_path__ + "img/taxNo.f86ce288.png";